/**
 * Clés de cache TanStack Query.
 *
 * Centralisées et structurées : des clés écrites à la main dans chaque
 * composant transforment l'invalidation en loterie — on invalide
 * `["planning"]` d'un côté et `["plannings"]` de l'autre, et le cache ne se
 * rafraîchit jamais. La hiérarchie compte aussi : invalider `["planning"]`
 * doit atteindre la semaine **et** la couverture.
 */
export const cles = {
  moi: ['moi'] as const,

  planning: {
    tout: ['planning'] as const,
    semaine: (lundi: string) => ['planning', 'semaine', lundi] as const,
    couverture: (debut: string, fin: string) =>
      ['planning', 'couverture', debut, fin] as const,
    conflits: (debut: string, fin: string) => ['planning', 'conflits', debut, fin] as const,
  },

  patients: {
    tout: ['patients'] as const,
    liste: (params: Record<string, string | number | undefined>) =>
      ['patients', 'liste', params] as const,
    detail: (id: string) => ['patients', 'detail', id] as const,
    ordonnances: (id: string) => ['patients', 'ordonnances', id] as const,
  },

  utilisateurs: {
    tout: ['utilisateurs'] as const,
    liste: () => ['utilisateurs', 'liste'] as const,
    detail: (id: string) => ['utilisateurs', 'detail', id] as const,
  },

  typesSoins: {
    tout: ['types-soins'] as const,
    liste: () => ['types-soins', 'liste'] as const,
  },

  disponibilites: {
    tout: ['disponibilites'] as const,
    semaine: (lundi: string, utilisateurId?: string) =>
      ['disponibilites', 'semaine', lundi, utilisateurId ?? 'tous'] as const,
  },

  absences: {
    tout: ['absences'] as const,
    liste: () => ['absences', 'liste'] as const,
  },

  facturation: {
    tout: ['facturation'] as const,
    apercu: (utilisateurId: string, debut: string, fin: string) =>
      ['facturation', 'apercu', utilisateurId, debut, fin] as const,
  },

  releves: {
    tout: ['releves'] as const,
    liste: () => ['releves', 'liste'] as const,
    detail: (id: string) => ['releves', 'detail', id] as const,
  },

  cabinet: ['cabinet'] as const,

  journalAudit: {
    tout: ['journal-audit'] as const,
    liste: (params: Record<string, string | number | undefined>) =>
      ['journal-audit', 'liste', params] as const,
  },
} as const
